import type { IWrapper } from './WrapperBlock.h'

import { styled } from '@linaria/react'
import { WrapperDisplay } from './WrapperBlock.h'

export const WrapperBlockSC = styled.div<IWrapper>`
  display: ${({ display }) => display || WrapperDisplay.BLOCK};
  margin: ${({ margin }) => margin || 'inherit'};
  padding: ${({ padding }) => padding || 'inherit'};
  flex-direction: ${({ flexDirection }) => flexDirection || 'inherit'};
  justify-content: ${({ justifyContent }) => justifyContent || 'inherit'};
  align-items: ${({ alignItems }) => alignItems || 'inherit'};
  width: ${({ width }) => width || 'auto'};
  height: ${({ height }) => height || 'auto'};
`
